import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 */
export const ExportProductsWithOversizeDimensionContentType = '' as const;
export type ExportProductsWithOversizeDimensionRequest = void;
export type ExportProductsWithOversizeDimensionResponses = LinkCommonErrorResponses & {
    /**
     * @description Exported products data
     */
    '200': {
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': string;
    };
};
export type ExportProductsWithOversizeDimensionResponseSuccess =
    ExportProductsWithOversizeDimensionResponses['200']['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
export type ExportProductsWithOversizeDimensionSearchParams = undefined;
export type ExportProductsWithOversizeDimensionPathParameters = undefined;
export const ExportProductsWithOversizeDimensionUrl = '/products/export/oversize-dimension' as const;
export const ExportProductsWithOversizeDimensionMethod = 'POST' as const;
export const getExportProductsWithOversizeDimensionUrl = (
    _params?: ExportProductsWithOversizeDimensionPathParameters
) => ExportProductsWithOversizeDimensionUrl;
